import { createSlice } from '@reduxjs/toolkit';
import { IMenu } from '../../../dashboard/components/left-menu/IMenu';
import { LeftMenuReducer } from '../../reducers/LeftMenuReducer';

const initialState: IMenu = {
	isClose: true,
	name: 'Left menu',
	list: [],
	rol: undefined,
};

export const leftMenuSlice = createSlice({
	name: 'left-menu',
	initialState,
	reducers: LeftMenuReducer,
});

export const { toggleMenu, setInitialMenu } = leftMenuSlice.actions;

export default leftMenuSlice.reducer;
